<template>
  <div class="addRole">
    <!--新增-->
    <el-dialog
      :title="$t('role.insertTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="400px"
    >
      <el-form
        ref="insertDialog"
        label-width="auto"
        :rules="rules"
        :model="addInfo"
        :label-position="'right'"
      >
        <el-form-item :label="$t('role.applicationName')" prop="applicationCode">
          <el-select
            v-model="addInfo.applicationCode"
            :placeholder="$t('role.appPlaceholder')"
            clearable
            style="width: 100%"
            filterable
          >
            <el-option
              v-for="item in applicationList"
              :key="item.applicationCode"
              :label="item.applicationName"
              :value="item.applicationCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('role.roleName')" prop="roleName">
          <el-input
            v-model="addInfo.roleName"
            :placeholder="$t('role.roleNamePlaceholder')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('role.remark')" prop="remark">
          <el-input
            v-model="addInfo.remark"
            :placeholder="$t('role.remarkPlaceholder')"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/role.js';
  export default {
    name: 'AddRole',
    data() {
      return {
        loading: false,
        dialogAdd: false,
        addInfo: {
          companyCode: '',
          applicationCode: '',
          roleName: '',
          remark: '',
        },
        companyList: [],
        applicationList: [],
      };
    },
    computed: {
      rules() {
        // 校验特殊字符
        var specialValidate = (rule, value, callback) => {
          var reg = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/;
          if (value.match(reg)) {
            callback(new Error(this.$t('menu.emoticons')));
          } else {
            callback();
          }
        };
        // 表单验证
        var validatePass = (rule, value, callback) => {
          if (value.replace(/(^\s*)|(\s*$)/g, '') === '') {
            // 前后去空格
            callback(new Error(this.$t('role.rolenameNotEmpty')));
          } else {
            callback();
          }
        };
        return {
          roleName: [
            {
              required: true,
              message: this.$t('role.rolenameNotEmpty'),
              trigger: 'blur',
            },
            {
              min: 1,
              max: 40,
              message: this.$t('menu.menunameWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
            { validator: validatePass, trigger: ['blur', 'change'] },
          ],
          companyCode: [
            {
              required: true,
              message: this.$t('role.companynameNotEmpty'),
              trigger: 'change',
            },
          ],
          applicationCode: [
            {
              required: true,
              message: this.$t('role.applicationNameNotEmpty'),
              trigger: 'change',
            },
          ],
          remark: [
            {
              min: 1,
              max: 400,
              message: this.$t('menu.remarkWordNumber'),
              trigger: ['blur', 'change'],
            },
            { validator: specialValidate, trigger: ['blur', 'change'] },
          ],
        };
      },
    },
    methods: {
      openDialog(flag) {
        if (this.$refs['insertDialog']) {
          this.$refs['insertDialog'].resetFields();
        }
        this.loading = false;
        this.dialogAdd = flag;
        this.changeCompany();
      },
      changeCompany() {
        this.addInfo.applicationCode = '';
        this.$axios.post(API.GET_APP_LIST_API).then((res) => {
          if (res.data.code === 0) {
            this.applicationList = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 保存
      addSure() {
        this.$refs.insertDialog.validate((valid) => {
          if (valid && !this.loading) {
            this.loading = true;
            this.$axios.post(API.ADD_ROLE_API, this.addInfo).then((res) => {
              this.loading = false;
              if (res.data.code !== 0) {
                this.$alert(res.data.msg);
              } else {
                this.dialogAdd = false;
                this.$emit('getData');
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              }
            });
          } else {
            return false;
          }
        });
      },
    },
  };
</script>
